import { loginAsTenant } from 'actionCreators/auth';
import Login from 'components/Login';
import { WithRouter } from 'decorators/withRouter';
import { IAuth } from 'interface/auth';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';

interface IRouteMatch {
  hash?: string;
  producer: string;
}

interface IProps extends RouteComponentProps<IRouteMatch> {
  loginAsTenant: typeof loginAsTenant;
  auth: IAuth;
}
@WithRouter()
class Admin extends Component<IProps> {
  componentDidMount() {
    this.switchToTenant();
  }
  componentDidUpdate() {
    this.switchToTenant();
  }
  switchToTenant() {
    const { auth, match } = this.props;
    if (
      auth?.isAuthenticated &&
      !auth?.isFetchingTenant &&
      auth?.tenantId !== parseInt(match.params.producer) &&
      !auth.tenantError
    ) {
      this.props.loginAsTenant(parseInt(this.props.match.params.producer));
    }
  }

  render() {
    const { auth, history, match } = this.props;
    if (!auth?.isAuthenticated) {
      return (
        <Fragment>
          <Login />
        </Fragment>
      );
    }
    if (auth?.tenantError || auth?.tenantId === parseInt(match.params.producer)) {
      history.push(`/curso/${this.props.match.params.hash}/`);
    }
    return null;
  }
}

const mapStateToProps = (state: any, props: any) => ({
  ...props,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  loginAsTenant,
})(Admin);
